import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { fadeAnimation, fadeOpacity } from '../../animations/animations';
import { MMIconsModule } from 'mm-ui';
import { FabPageHomepagesModule } from '../../components/cms/content/fab-page-homepages/fab-page-homepages.module';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [
    CommonModule,
    MMIconsModule,
    FabPageHomepagesModule
  ],
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  animations: [fadeOpacity, fadeAnimation]
})
export class ScrollToTopComponent implements OnInit {

  windowScrolled: boolean;
  constructor(@Inject(DOCUMENT) private document: Document) { }
  @HostListener("window:scroll", [])

  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 800) {
      this.windowScrolled = true;
    }
    else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.scrollTo(0, 0);
      }
    })();
  }

  ngOnInit() { }
}

